import { useMemo } from 'react';
import { isLiveStream } from '@core/livestream/helpers';
import { idsToInteractions } from '@embed/components/VideoPlayer/Player3/components/Interactions/helpers';
import { useLinkInteractions } from '@embed/components/VideoPlayer/Player3/components/Interactions/hooks/useLinkInteractions/useLinkInteractions';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { currentLiveStreamIdSelector } from '@embed/components/VideoPlayer/Player3/store/selectors';
/**
 * Handle all interactions in their various states
 */
export function useAnyInteractionState() {
    const { expandedInteractionId, visibleInteractionIds, activeInteractionIds, actions: { setExpandedInteractionId }, video, } = useStore((store) => store);
    const activeLinks = useLinkInteractions();
    const liveStreamId = useStore(currentLiveStreamIdSelector);
    const livestreamInteractions = useStore((state) => state.liveStreams[liveStreamId ?? '']?.interactions);
    const allInteractions = useMemo(() => isLiveStream(video) ? livestreamInteractions : video?.interactions ?? [], [video, livestreamInteractions]);
    const visibleInteractions = useMemo(() => [
        ...idsToInteractions(visibleInteractionIds, allInteractions),
        ...activeLinks,
    ], [visibleInteractionIds, allInteractions, activeLinks]);
    const activeInteractions = useMemo(() => [
        ...idsToInteractions(activeInteractionIds, allInteractions),
        ...activeLinks,
    ], [activeInteractionIds, allInteractions, activeLinks]);
    const expandedInteraction = useMemo(() => allInteractions?.find((interaction) => expandedInteractionId === interaction.id), [expandedInteractionId, allInteractions]);
    return {
        setExpandedInteractionId,
        isAnyInteractionVisible: visibleInteractions.length > 0,
        isAnyInteractionExpanded: expandedInteractionId !== null,
        isAnyInteractionActive: activeInteractions.length > 0,
        visibleInteractions,
        activeInteractions,
        expandedInteraction,
    };
}
